import { RefObject } from "react"
import { cn } from "@/lib/utils"
import { Message } from "./types"
import { ChatMessage } from "./ChatMessage"

interface ChatMessagesProps {
  messages: Message[]
  messagesEndRef: RefObject<HTMLDivElement | null>
  sessionId: string
  onFeedbackSubmit: (
    messageContent: string,
    feedbackType: "positive" | "negative",
    comment: string
  ) => Promise<void>
  /**
   * Density override for compact hosts: the standalone app keeps the default
   * p-6/space-y-6 rhythm, while the ~360px embed panel passes tighter values
   * so the generous standalone padding never leaks into it.
   */
  className?: string
}

export function ChatMessages({
  messages,
  messagesEndRef,
  sessionId,
  onFeedbackSubmit,
  className,
}: ChatMessagesProps) {
  return (
    <div
      className={cn(
        "insight-scroll h-full w-full space-y-6 overflow-x-hidden p-6",
        messages.length > 0 ? "overflow-y-auto" : "overflow-hidden",
        className
      )}
    >
      {messages.length === 0 ? (
        <div className="flex h-full flex-col items-center justify-center gap-2">
          <span className="label-mono">
            <span className="text-brand-coral">∕∕</span>&nbsp;&nbsp;Empty session
          </span>
          <p className="text-sm text-muted-foreground">Ask a question below to get started.</p>
        </div>
      ) : (
        messages.map((message, index) => (
          <ChatMessage
            key={index}
            message={message}
            sessionId={sessionId}
            onFeedbackSubmit={async (feedbackType, comment) => {
              await onFeedbackSubmit(message.content, feedbackType, comment)
            }}
          />
        ))
      )}
      <div ref={messagesEndRef} />
    </div>
  )
}
